// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3YVR4","errorLogs":"styles_errorLogs__35OUg"};